import React from 'react';
export function StorySection() {
  return <section className="py-16 md:py-24 px-4 bg-white relative" data-id="element-461">
      <div className="max-w-3xl mx-auto" data-id="element-462">
        <div className="prose prose-lg md:prose-xl prose-p:text-dark/80 prose-p:leading-relaxed mx-auto" data-id="element-463">
          <p className="font-serif text-2xl md:text-3xl font-bold text-forest mb-8" data-id="element-464">
            Imagínate esto.
          </p>

          <p data-id="element-465">Son las 8 de la noche.</p>

          <p data-id="element-466">
            Cruzas la puerta de tu casa arrastrando el cansancio de un día
            interminable. El trabajo, los compromisos, las responsabilidades.
            Todo pesa.
          </p>

          <p data-id="element-467">
            Lo primero que sientes es ese vacío en el estómago... mezclado con
            esa presión en el vientre que ya llevas horas ignorando.
          </p>

          <p data-id="element-468">Te miras de reojo en el espejo del pasillo.</p>

          <p data-id="element-469">Y ahí está.</p>

          <p data-id="element-470">
            Ese abdomen que por la mañana estaba razonablemente bien... y que
            ahora parece el de alguien completamente diferente.
          </p>

          <p data-id="element-471">Aprietas los labios. Respiras. Y te dices lo de siempre:</p>

          <p className="italic font-medium text-forest text-xl md:text-2xl my-6 text-center" data-id="element-472">
            "Mañana como mejor."
          </p>

          <p data-id="element-473">
            Vas a la cocina. Buscas algo rápido y "sano". Una ensalada. Un
            yogur. Un poco de pan integral con algo.
          </p>

          <p data-id="element-474">Te vas a la cama.</p>

          <p data-id="element-475">
            Tu sueño es ligero. Te despiertas una o dos veces. A las 7 AM suena
            el despertador y te sientes más cansada que cuando te acostaste.
          </p>

          <p data-id="element-476">Y lo primero que ves al levantarte... es ese espejo de nuevo.</p>
        </div>

        {/* Empathy Callout */}
        <div className="mt-12 p-6 md:p-8 bg-cream-dark/50 border-l-4 border-gold rounded-r-xl shadow-sm" data-id="element-477">
          <p className="text-lg md:text-xl font-medium text-dark mb-4" data-id="element-478">
            💬 Si esto te suena familiar, no es tu culpa. Y no es falta de
            voluntad.
          </p>
          <p className="text-lg md:text-xl font-bold text-forest" data-id="element-479">
            Es que nadie te explicó lo que realmente le pasa a tu cuerpo después
            de los 35.
          </p>
        </div>
      </div>
    </section>;
}